<template>
<nav class="navigation-bar" :class="navbarClass">
  <div class="container pt-3">
    <div class="row no-gutters">
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(0)? 'active': ''" @click="scrollTo(0)">
          top
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(1)? 'active': ''" @click="scrollTo(1)">
          concept
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(2)? 'active': ''" @click="scrollTo(2)">
          news
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(3)? 'active': ''" @click="scrollTo(3)">
          brand
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(4)? 'active': ''" @click="scrollTo(4)">
          type
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(5)? 'active': ''" @click="scrollTo(5)">
          library
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(6)? 'active': ''" @click="scrollTo(6)">
          information
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(7)? 'active': ''" @click="scrollTo(7)">
          reservation
        </button>
      </div><!-- /.col -->
      <div class="col text-center">
        <button type="btn" class="btn btn-spray" :class="isActive(8)? 'active': ''" @click="scrollTo(8)">
          online store
        </button>
      </div><!-- /.col -->
    </div>
  </div>
  <div class="bottle" :class="leftItemClass">
    <svg xmlns="http://www.w3.org/2000/svg" width="152" height="274" viewBox="0 0 151.99 273.6">
      <path fill="currentColor" d="M140.1,68.3H111.63V16.51c0-3.07-12.75-5.57-28.47-5.57S54.7,13.44,54.7,16.51V68.3H14.34V273.6H152V68.3Z"/>
      <polygon fill="currentColor" points="111.63 57.36 111.63 62.27 137.65 62.27 137.65 68.3 142.56 68.3 142.56 57.36 111.63 57.36"/>
      <path fill="currentColor" d="M71.28,0C64,0,40.36.58,40.36,8V57.36H0V267.57H14.34v-4.91H4.91V62.27H54.76V57.36H45.27V8.51C47,7.2,56,4.91,71.28,4.91s24.25,2.29,26,3.6V12h4.91V8C102.2.58,78.53,0,71.28,0Z"/>
      <polygon fill="#999999" points="111.63 62.27 111.63 57.36 102.2 57.36 102.2 11.99 97.29 11.99 97.29 57.36 54.76 57.36 54.76 62.27 102.2 62.27 111.63 62.27"/>
      <polygon fill="#999999" points="137.65 68.3 137.65 262.66 14.34 262.66 14.34 267.57 142.56 267.57 142.56 68.3 137.65 68.3"/>
      <path fill="#999999" d="M115.82,136.28H26.74v92.19h89.08Zm-4.92,87.27H31.66V141.19H110.9Z"/>
    </svg>
  </div>
  <div class="vertical-typo d-none d-lg-block" :class="leftItemClass">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.63 231.53">
      <path fill="currentColor" d="M3.12,5.35c0,1,0,1.13.1,1.32s.43.21.81.25c.08,0,.1,0,.1.12s0,.13-.1.13c-.43,0-1,0-1.4,0s-.9,0-1.29,0c-.08,0-.1,0-.1-.12s0-.12.09-.13c.35,0,.61,0,.72-.25a3.46,3.46,0,0,0,.12-1.32V1.8c0-.95,0-1.07-.11-1.29S1.64.32,1.25.28c-.06,0-.08,0-.08-.12s0-.16.08-.16C2.09,0,3,.05,3.83.05s1.63,0,2.5,0c0,.51.12,1.11.19,1.62,0,.06,0,.1-.12.12s-.13,0-.15-.07a2.44,2.44,0,0,0-.64-1A2.52,2.52,0,0,0,4.07.36c-.37,0-.72,0-.85.25a3.35,3.35,0,0,0-.1,1.19V3.26h.62a2.82,2.82,0,0,0,1.33-.19,1.06,1.06,0,0,0,.3-.66c0-.07,0-.1.14-.1s.14,0,.14.1c0,.34,0,.67,0,1s0,.78,0,1.13c0,.07,0,.11-.13.11s-.13,0-.15-.11a1.16,1.16,0,0,0-.32-.73,2.84,2.84,0,0,0-1.31-.21,6.12,6.12,0,0,0-.62,0Z"/>
      <path fill="currentColor" d="M2.58,17.14c0,1,0,1.13.11,1.33s.4.2.77.24c.08,0,.1,0,.1.14s0,.12-.1.12c-.43,0-.92,0-1.33,0s-.9,0-1.29,0c-.08,0-.1,0-.1-.12s0-.13.1-.14c.34,0,.62-.05.73-.24a3.56,3.56,0,0,0,.12-1.33V13.59c0-.95,0-1.06-.11-1.27s-.46-.21-.84-.25c-.06,0-.08,0-.08-.12s0-.15.08-.15c.43,0,1,0,1.34,0s1-.05,1.64-.05c1.83,0,2.56.8,2.56,1.82a1.89,1.89,0,0,1-1.61,1.78c.4.77.86,1.59,1.39,2.43a2.26,2.26,0,0,0,.6.75,1.66,1.66,0,0,0,.61.14c.06,0,.08,0,.08.13s0,.13-.09.13c-.37,0-.66,0-1,0H5.56a6.75,6.75,0,0,0-.37-.77L3.74,15.54l-.44,0c-.25,0-.48,0-.72,0Zm0-2a5.43,5.43,0,0,0,.72.05c1.42,0,2-.71,2-1.57s-.54-1.54-1.74-1.54c-.33,0-.67,0-.8.19a3,3,0,0,0-.13,1.27Z"/>
      <path fill="currentColor" d="M4.7,28c-.34,0-.77,0-1.15,0s-.81,0-1.25,0l-.4,1.1a1.69,1.69,0,0,0-.16,1.13c.09.2.43.24.8.28.06,0,.09,0,.09.13s0,.13-.1.13c-.37,0-.86,0-1.22,0s-.7,0-1,0c-.08,0-.1,0-.1-.13s0-.12.1-.13a.92.92,0,0,0,.57-.26,4.22,4.22,0,0,0,.6-1.19l1.19-3.17c.49-1.33.59-1.61.74-2.12L4,23.46a.1.1,0,0,1,.11.08c.19.62.35,1.12.79,2.4l1.13,3.2a4.65,4.65,0,0,0,.49,1.12c.16.2.34.22.7.25.09,0,.11,0,.11.13s0,.13-.11.13c-.4,0-.94,0-1.34,0s-.91,0-1.31,0c-.07,0-.09,0-.09-.13s0-.12.09-.13c.33,0,.65-.05.72-.25s0-.5-.19-1ZM4,26c-.23-.65-.34-1-.47-1.37L3,25.94l-.6,1.66c.35,0,.74,0,1.11,0s.71,0,1,0Z"/>
      <path fill="currentColor" d="M6.55,37.15c0,.07,0,.11-.11.12s-.13,0-.15-.06A2.77,2.77,0,0,0,5.43,36a2.26,2.26,0,0,0-1.38-.45c-1.5,0-2.68,1.4-2.68,3.38s1.17,3.41,2.82,3.41a2.5,2.5,0,0,0,1.69-.58,4.47,4.47,0,0,0,0-.67c0-1,0-1.1-.12-1.32s-.39-.21-.77-.25c-.07,0-.09,0-.09-.14s0-.12.09-.12c.41,0,.91,0,1.3,0s.78,0,1.2,0c.07,0,.09,0,.09.12s0,.13-.09.14c-.34,0-.51,0-.63.25A3,3,0,0,0,6.78,41a13.61,13.61,0,0,0,.06,1.45s0,.07-.1.06l-.52,0a21.13,21.13,0,0,1-2.2.27A3.57,3.57,0,0,1,.27,39a3.65,3.65,0,0,1,3.78-3.74,4.69,4.69,0,0,1,1.23.17,2.51,2.51,0,0,0,1.1.1C6.41,36,6.47,36.63,6.55,37.15Z"/>
      <path fill="currentColor" d="M2.58,52.54c0,1,0,1.13.11,1.33s.4.2.77.24c.08,0,.1,0,.1.14s0,.12-.1.12c-.43,0-.92,0-1.33,0s-.9,0-1.29,0c-.08,0-.1,0-.1-.12s0-.13.1-.14c.34,0,.62,0,.73-.24a3.56,3.56,0,0,0,.12-1.33V49c0-1,0-1.06-.11-1.27s-.46-.21-.84-.25c-.06,0-.08,0-.08-.12s0-.15.08-.15c.43,0,1,0,1.34,0s1-.05,1.64-.05c1.83,0,2.56.8,2.56,1.82a1.89,1.89,0,0,1-1.61,1.78c.4.77.86,1.59,1.39,2.43a2.26,2.26,0,0,0,.6.75,1.66,1.66,0,0,0,.61.14c.06,0,.08,0,.08.13s0,.13-.09.13c-.37,0-.66,0-1,0H5.56a6.75,6.75,0,0,0-.37-.77L3.74,50.94,3.3,51c-.25,0-.48,0-.72,0Zm0-1.95a5.43,5.43,0,0,0,.72,0c1.42,0,2-.71,2-1.57s-.54-1.54-1.74-1.54c-.33,0-.67,0-.8.19A3,3,0,0,0,2.58,49Z"/>
      <path fill="currentColor" d="M4.7,63.4c-.34,0-.77,0-1.15,0s-.81,0-1.25,0l-.4,1.1a1.69,1.69,0,0,0-.16,1.13c.09.2.43.24.8.28.06,0,.09,0,.09.13s0,.13-.1.13c-.37,0-.86,0-1.22,0s-.7,0-1,0c-.08,0-.1,0-.1-.13s0-.12.1-.13a.92.92,0,0,0,.57-.26,4.22,4.22,0,0,0,.6-1.19l1.19-3.17c.49-1.33.59-1.61.74-2.12L4,58.86a.1.1,0,0,1,.11.08c.19.62.35,1.12.79,2.4l1.13,3.2a4.65,4.65,0,0,0,.49,1.12c.16.2.34.22.7.25.09,0,.11,0,.11.13s0,.13-.11.13c-.4,0-.94,0-1.34,0s-.91,0-1.31,0c-.07,0-.09,0-.09-.13s0-.12.09-.13c.33,0,.65,0,.72-.25s0-.5-.19-1Zm-.7-2c-.23-.65-.34-1-.47-1.37L3,61.34,2.44,63c.35,0,.74,0,1.11,0s.71,0,1,0Z"/>
      <path fill="currentColor" d="M1.52,71.86l0,4.3a3,3,0,0,0,.18,1.29c.13.2.43.23.76.27.07,0,.08,0,.08.12s0,.12-.08.12l-1.15,0c-.37,0-.81,0-1.15,0-.08,0-.11,0-.11-.11s0-.12.1-.13c.3,0,.56-.07.69-.28a3.06,3.06,0,0,0,.19-1.28l.06-3.57A2.4,2.4,0,0,0,1,71.38a1.21,1.21,0,0,0-.81-.29c-.08,0-.1,0-.1-.13s0-.16.1-.16l1,0h1A13.21,13.21,0,0,0,2.88,72l2.28,3.34c.34.49.62.91.93,1.4V72.59a2.81,2.81,0,0,0-.2-1.25c-.12-.2-.42-.22-.74-.26-.08,0-.1,0-.1-.13s0-.15.09-.15c.37,0,.77,0,1.13,0s.81,0,1.13,0c.08,0,.1,0,.1.15s0,.12-.1.13c-.3,0-.55.06-.67.26a3.06,3.06,0,0,0-.19,1.25l-.06,3.57c0,.67,0,1.16,0,1.69-.49.27-.51.28-.54.28a.1.1,0,0,1-.08,0c-.31-.51-.54-.85-1.14-1.72l-3.09-4.5Z"/>
      <path fill="currentColor" d="M6.82,84.37c0,.07,0,.1-.1.12a.12.12,0,0,1-.16-.07,3.13,3.13,0,0,0-.85-1.2,2.35,2.35,0,0,0-1.34-.43c-1.49,0-2.58,1.33-2.58,3.37,0,1.81,1.11,3.2,2.65,3.2A2.67,2.67,0,0,0,6.9,88s.08-.07.2,0a.12.12,0,0,1,.07.18A3.1,3.1,0,0,1,4.3,89.93a3.74,3.74,0,0,1,0-7.48,5,5,0,0,1,1.22.15,2.27,2.27,0,0,0,1.11.11C6.7,83.23,6.76,83.85,6.82,84.37Z"/>
      <path fill="currentColor" d="M2.85,99.75A2.85,2.85,0,0,0,3,101c.16.26.54.27,1,.27a2.64,2.64,0,0,0,1.74-.41,3.12,3.12,0,0,0,.77-1c0-.06,0-.09.15-.06s.12.08.1.14a10.6,10.6,0,0,1-.52,1.69c-.86,0-1.71,0-2.52,0s-1.77,0-2.62,0c-.06,0-.08,0-.08-.13s0-.12.08-.13c.35,0,.59,0,.71-.24a3.49,3.49,0,0,0,.12-1.32V96.2c0-1,0-1.07-.11-1.29s-.38-.19-.76-.23c-.08,0-.09,0-.09-.12s0-.16.09-.16c.82,0,1.71,0,2.53,0s1.61,0,2.47,0c0,.51.1,1.12.17,1.62,0,.06,0,.1-.09.12s-.15,0-.17-.07a2.26,2.26,0,0,0-.65-1,2.21,2.21,0,0,0-1.49-.32c-.38,0-.72,0-.86.25a3.13,3.13,0,0,0-.1,1.19v1.43h.62a2.38,2.38,0,0,0,1.29-.21.9.9,0,0,0,.33-.65c0-.06,0-.09.12-.09s.14,0,.14.09c0,.35,0,.67,0,1s0,.77,0,1.13c0,.07,0,.1-.14.1s-.11,0-.12-.1a1.15,1.15,0,0,0-.35-.74A2.77,2.77,0,0,0,3.47,98H2.85Z"/>
      <path fill="currentColor" d="M3.23,121.63c-1-.51-1.55-1-1.55-2a1.91,1.91,0,0,1,2.12-1.78,2.8,2.8,0,0,1,.88.14,2.46,2.46,0,0,0,1,0c0,.5.07,1.08.11,1.6,0,.05,0,.08-.12.1s-.11,0-.12-.07a1.93,1.93,0,0,0-1.7-1.5,1.18,1.18,0,0,0-1.25,1.24c0,.49.24.93,1.12,1.35l.51.24c1.17.55,1.86,1.05,1.86,2.22s-.76,2.12-2.51,2.12a5.53,5.53,0,0,1-1.8-.35,13.18,13.18,0,0,1-.33-1.61c0-.05,0-.1.1-.12s.14,0,.16.06a2.37,2.37,0,0,0,2,1.7,1.39,1.39,0,0,0,1.5-1.41c0-.81-.48-1.23-1.46-1.73Z"/>
      <path fill="currentColor" d="M1.9,135.15c0,1,0,1.14.1,1.34s.42.19.8.23c.08,0,.1,0,.1.12s0,.13-.1.13c-.43,0-1,0-1.37,0s-.91,0-1.31,0c-.06,0-.08,0-.08-.12s0-.12.08-.13c.36,0,.62,0,.73-.23A3.17,3.17,0,0,0,1,135.15V131.6c0-.95,0-1.07-.12-1.29s-.39-.19-.78-.23c-.07,0-.08,0-.08-.12s0-.16.08-.16c.42,0,1,.06,1.35.06s.92,0,1.31-.06c.08,0,.11,0,.11.16s0,.11-.1.12c-.35,0-.62,0-.74.23a3.54,3.54,0,0,0-.11,1.29V133c.67,0,1.26,0,1.89,0s1.2,0,1.84,0V131.6c0-.95,0-1.08-.11-1.29s-.41-.19-.78-.23c-.07,0-.09,0-.09-.12s0-.16.09-.16c.42,0,1,.06,1.37.06s.9,0,1.3-.06c.09,0,.11,0,.11.15s0,.12-.1.13c-.37,0-.62,0-.73.23a3.29,3.29,0,0,0-.13,1.29v3.55c0,1,0,1.13.12,1.34s.41.19.8.23c.07,0,.08,0,.08.13s0,.12-.08.12c-.45,0-1,0-1.37,0s-.93,0-1.32,0c-.07,0-.09,0-.09-.12s0-.12.09-.13c.36,0,.61,0,.72-.23a3.62,3.62,0,0,0,.12-1.34v-1.72c-.64,0-1.22,0-1.84,0s-1.22,0-1.89,0Z"/>
      <path fill="currentColor" d="M7.48,145.16a3.63,3.63,0,0,1-3.71,3.77,3.75,3.75,0,0,1,0-7.49A3.58,3.58,0,0,1,7.48,145.16Zm-6.31,0c0,2.08,1.05,3.42,2.6,3.42s2.6-1.34,2.6-3.39-1.08-3.41-2.6-3.41S1.17,143.14,1.17,145.16Z"/>
      <path fill="currentColor" d="M2.77,158.75c0,1,0,1.13.1,1.31s.43.21.81.25c.08,0,.1,0,.1.13s0,.13-.1.13c-.43,0-1,0-1.35,0s-1,0-1.34,0c-.07,0-.08,0-.08-.13s0-.12.08-.13c.36,0,.62,0,.74-.25a3.73,3.73,0,0,0,.11-1.31V155.2c0-.95,0-1.06-.1-1.28s-.46-.2-.83-.24c-.07,0-.09,0-.09-.13s0-.15.09-.15c.42,0,1,0,1.38,0s1-.06,1.65-.06c2,0,2.65.77,2.65,1.88s-.65,2-3,2a6.46,6.46,0,0,1-.78,0Zm0-1.85a4.1,4.1,0,0,0,.74.06c1.5,0,2.05-.74,2.05-1.65s-.68-1.58-1.83-1.58c-.3,0-.69,0-.82.21a2.78,2.78,0,0,0-.14,1.25Z"/>
      <path fill="currentColor" d="M2.49,182.35c0,1,0,1.12.12,1.32s.38.2.76.24c.07,0,.09,0,.09.13s0,.13-.09.13c-.43,0-.94,0-1.34,0s-.91,0-1.28,0c-.08,0-.09,0-.09-.13s0-.12.09-.13c.33,0,.59,0,.71-.24a3.49,3.49,0,0,0,.12-1.32V178.8c0-1,0-1.06-.11-1.28s-.41-.2-.77-.24c-.07,0-.08,0-.08-.12s0-.16.08-.16c.4,0,.93.06,1.33.06s.89,0,1.28-.06c.08,0,.1,0,.1.15s0,.12-.1.13c-.35,0-.57.05-.69.24a3.2,3.2,0,0,0-.13,1.28v1.51c.31-.26.53-.47.8-.74l1.1-1.11c.64-.64.75-.81.7-1s-.31-.14-.5-.16-.09,0-.09-.13,0-.13.09-.13c.37,0,.76,0,1.13,0s.79,0,1.17-.06c.07,0,.08,0,.08.15s0,.12-.08.13a1.94,1.94,0,0,0-.85.3,7.2,7.2,0,0,0-1.21,1l-1,.91-.57.54c.61.71,1.34,1.56,2.42,2.78a4.41,4.41,0,0,0,1,.94,1.77,1.77,0,0,0,.65.16c.06,0,.08,0,.08.13s0,.13-.09.13c-.34,0-.64,0-.91,0H5.61c-.27-.36-.51-.67-.85-1.07l-2.27-2.65Z"/>
      <path fill="currentColor" d="M3.28,193.08c0-.14,0-.28,0-.41L2.86,192l-.93-1.54a6.73,6.73,0,0,0-.74-1.12.91.91,0,0,0-.67-.26c-.06,0-.08,0-.08-.12s0-.15.08-.15c.43,0,.9,0,1.3,0s.9,0,1.31,0c.06,0,.08,0,.08.15s0,.11-.08.12c-.33,0-.6.06-.64.25s.06.38.28.78l.91,1.54.35.56c.1-.16.19-.31.31-.53l.83-1.5c.27-.47.33-.62.26-.83s-.32-.23-.67-.27c-.07,0-.09,0-.09-.12s0-.15.1-.15c.37,0,.81,0,1.19,0s.69,0,1.07,0c.06,0,.08,0,.08.15s0,.11-.09.12a1.37,1.37,0,0,0-.7.27,4.26,4.26,0,0,0-.76,1l-.93,1.51c-.16.27-.28.45-.42.68s0,.36,0,.51v1c0,1,0,1.13.1,1.33s.43.21.82.25c.06,0,.08,0,.08.13s0,.12-.08.12c-.46,0-1,0-1.38,0s-.9,0-1.29,0c-.09,0-.1,0-.1-.12s0-.12.1-.13c.34,0,.6-.05.71-.25a3.32,3.32,0,0,0,.12-1.33Z"/>
      <path fill="currentColor" d="M7.48,204.16a3.63,3.63,0,0,1-3.71,3.77,3.75,3.75,0,0,1,0-7.49A3.58,3.58,0,0,1,7.48,204.16Zm-6.31,0c0,2.08,1.05,3.42,2.6,3.42s2.6-1.34,2.6-3.39-1.08-3.41-2.6-3.41S1.17,202.14,1.17,204.16Z"/>
      <path fill="currentColor" d="M3.28,214.2c0-.91,0-1.06-.11-1.26s-.39-.18-.64-.18a1.79,1.79,0,0,0-1.16.31,2.43,2.43,0,0,0-.67,1c0,.06,0,.09-.16.07s-.1,0-.1-.12c.06-.5.14-1.14.18-1.65,1.09,0,2.11,0,3.14,0s2.08,0,3.18,0c0,.51.11,1.15.17,1.65,0,.07,0,.1-.1.12s-.14,0-.16-.07a2.29,2.29,0,0,0-.66-1,1.85,1.85,0,0,0-1.2-.31c-.25,0-.51,0-.65.2a2.84,2.84,0,0,0-.13,1.24v3.55c0,1,0,1.1.11,1.31s.45.2.81.24c.07,0,.09,0,.09.13s0,.14-.09.14c-.42,0-1,0-1.38,0s-.93,0-1.31,0c-.07,0-.09,0-.09-.13s0-.13.09-.14c.33,0,.62-.05.73-.24a3.52,3.52,0,0,0,.11-1.31Z"/>
      <path fill="currentColor" d="M7.48,227.76a3.63,3.63,0,0,1-3.71,3.77,3.75,3.75,0,0,1,0-7.49A3.58,3.58,0,0,1,7.48,227.76Zm-6.31,0c0,2.08,1.05,3.42,2.6,3.42s2.6-1.34,2.6-3.39-1.08-3.41-2.6-3.41S1.17,225.74,1.17,227.76Z"/>
    </svg>
  </div>
</nav>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  mounted() {
  },
  computed: {
    ...mapState({
      currentPage: state => state.currentPage,
      brandNavigationShowing: state => state.brandNavigationShowing,
      typeNavigationShowing: state => state.typeNavigationShowing,
    }),
    navbarClass() {
      if (this.$route.name === 'Home') {
        if (this.currentPage == 0 || this.currentPage == 1 || this.currentPage == 7 || this.currentPage == 8) {
          return 'white'
        } 
      }
      return 'black'
    },
    leftItemClass() {
      if (this.brandNavigationShowing || this.typeNavigationShowing) {
        return 'fadeout'
      } else {
        if (this.$route.name === 'Home') {
          if (this.currentPage == 0 || this.currentPage == 1 || this.currentPage == 7 || this.currentPage == 8) {
            return 'white'
          } 
        }
        return 'black'
      }
    }
  },
  methods: {
    scrollTo(index) {
      if (this.$route.name == 'Home') {
        this.storePage(index)
      } else {
        if (index == 0) {
          this.$router.push({name: 'Home', hash: '#top'})
        } else if (index == 1) {
          this.$router.push({name: 'Home', hash: '#concept'})
        } else if (index == 2) {
          this.$router.push({name: 'Home', hash: '#news'})
        } else if (index == 3) {
          this.$router.push({name: 'Home', hash: '#brand'})
        } else if (index == 4) {
          this.$router.push({name: 'Home', hash: '#type'})
        } else if (index == 5) {
          this.$router.push({name: 'Home', hash: '#library'})
        } else if (index == 6) {
          this.$router.push({name: 'Home', hash: '#information'})
        } else if (index == 7) {
          this.$router.push({name: 'Home', hash: '#reservation'})
        } else if (index == 8) {
          this.$router.push({name: 'Home', hash: '#onlinestore'})
        }
      }
    },
    ...mapActions({
      storePage: 'doSetPage'
    }),
    isActive(index) {
      // TODO: Activeかどうかの判定
      if (this.$route.name == 'Home') {
        if (index == this.currentPage) {
          return true
        }
      } else if (this.$route.name == 'Brand' && index == 3) {
        return true
      } else if (this.$route.name == 'Type' && index == 4) {
        return true
      } else if (this.$route.name == 'Information' && index == 6) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.navigation-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 20;
  .btn-spray {
    &:focus {
      box-shadow: none;
    }
    &.active {
      &:after {
        content: '●';
        display: block;
        font-size: 7px;;
      }
    }
  }

  &.white {
    .btn-spray {
      color: #fff;
    
    }
  }
}
.bottle {
  position: fixed;
  top: 15px;
  left: 20px;
  width: 25px;
  color: #000;
  transition-property: color, opacity;
  transition-duration: 0.3s;
  opacity: 1;
  &.white {
    color: #fff;
  }
  &.fadeout {
    opacity: 0;
    pointer-events: none;
  }
  >svg {
    width: 100%;
    height: auto;
  }
}
.vertical-typo {
  position: fixed;
  top: calc(50vh - 140px);
  left: 30px;
  width: 8px;
  color: #000;
  transition-property: color, opacity;
  transition-duration: 0.3s;
  opacity: 1;
  &.white {
    color: #fff;
  }
  &.fadeout {
    opacity: 0;
    pointer-events: none;
  }
  >svg {
    width: 100%;
    height: auto;
  }
}
</style>